import { OptionsFileIcon } from 'assets/icons/OptionsFileIcon'
import { IconContainer } from 'pages/Accomodation/Accommodation.style'
import { Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'

export const NoData = ({ icon }: { icon?: any }) => {
    return <Flex center justcenter height='100%' column gap='1rem' >
        <IconContainer>
            {icon || <OptionsFileIcon />}
        </IconContainer>
        <TitleText>There is no data for display</TitleText>
    </Flex>
}